<template>
  <div class="consume-detail-card">
    <div class="title">
      <span>消费明细(2)</span>
      <span class="other">清空</span>
    </div>
    <template :key="item" v-for="item in consumeList">
      <div :style="{height:isCustomCard?'auto':'194px'}" class="item">
        <div class="close">
          <el-icon>
            <close />
          </el-icon>
        </div>
        <div class="top">
          <div class="name">{{ item.name }}</div>
          <div class="buy-num">
            <el-input-number v-model="buyNum" :min="1" :max="10" @change="handleChange" />
          </div>
          <div class="price">¥{{ item.price.toFixed(2) }}</div>
        </div>

        <div :class="{ customCardActive: isCustomCard }" class="bottom">
          <div class="left">
            <template v-if="item.state == 1">理疗师：{{ item.teacher }}</template>
            <template v-else>
              <div>+ 选择理疗师</div>
            </template>
          </div>
          <div v-if="!isCustomCard" class="right">
            <el-select v-model="value" class="m-2" placeholder="请选择权益" size="large">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="value" class="m-2" placeholder="请选择充值卡" size="large">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div v-if="isCustomCard" class="selected-item">
          <div class="titles">
            <div>已选项目</div>
            <div>原价</div>
            <div>单价</div>
            <div>可用次数</div>
            <div>小计</div>
            <div>操作</div>
          </div>
          <div class="select-list">
            <template :key="item" v-for="item in customCardSelectList">
              <div class="select-content">
                <div class="name">{{ item.name }}</div>
                <div class="old-price">{{ item.oldPrice }}</div>
                <div class="price">
                  <el-input v-model="input">
                    <template #suffix>| 元</template>
                  </el-input>
                </div>
                <div class="use-num">
                  <el-input-number v-model="num" :min="1" :max="10" @change="handleChange" />
                </div>
                <div class="total">
                  <el-input v-model="input">
                    <template #suffix>| 元</template>
                  </el-input>
                </div>
                <div class="handle">删除</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'

export default defineComponent({
  props: {
    consumeList: {
      type: Array,
      default() {
        return []
      }
    },
    isCustomCard: {
      type: Boolean,
      default: false
    },
    customCardSelectList: {
      type: Array,
      default() {
        return []
      }
    }

  },
  components: {

  },
  setup() {
    const buyNum = ref(1)

    return {
      buyNum
    }

  }
})
</script>

<style scoped lang="less">
.consume-detail-card {
  margin-top: 20px;
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: rgba(80, 80, 80, 1);
    margin-bottom: 20px;
    .other {
      color: rgba(255, 87, 51, 1);
    }
  }
  .item {
    color: rgba(80, 80, 80, 1);
    background-color: rgba(239, 239, 239, 1);
    border-radius: 5px;
    font-size: 14px;
    padding: 20px;
    height: 194px;
    position: relative;
    margin-bottom: 10px;
    .close {
      position: absolute;
      right: 10px;
      top: 4px;

      i {
        font-size: 24px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .buy-num {
        &:deep(.el-input-number) {
          max-width: 120px;
        }
      }
      .name,
      .price {
        color: rgba(80, 80, 80, 1);
        // color: var(--borderColor);
        font-size: 16px;
        font-weight: bold;
        padding-right: 42px;
      }
    }
    .customCardActive {
      position: relative !important;
      border-top: none !important;
      margin: 10px 0;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      width: 94%;
      bottom: 20px;
      border-top: 1px solid #bfbfbf;
      padding-top: 20px;

      &:deep(.el-select) {
        max-width: 120px;
        margin-left: 10px;
      }
    }
    .selected-item {
      .titles {
        display: flex;
        background-color: rgba(186, 186, 186, 1);
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        div {
          flex: 1;
          text-align: center;
        }
      }
      .select-list {
        .select-content {
          display: flex;
          margin: 10px 0;
          .price,.total{
            &:deep(.el-input){
              max-width: 100px;
            }
          }
          & > div {
            flex: 1;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:deep(.el-input-number) {
              max-width: 120px;
              .el-input-number__decrease {
              }
            }
          }
        }
      }
    }
  }
}
</style>

